// extracted by mini-css-extract-plugin
export default {"content":"HuntForm_content__IJNnj","footer":"HuntForm_footer__BsWo4","wrapper":"HuntForm_wrapper__wXTk2"};